export const en = {
  kicker: "HELLO",
  headingLine1: "I'm Levy Santiago,",
  headingLine2: "back-end engineer",
  body: "Six-plus years building systems that impact people's lives, using AI as part of my toolbox.",
  primaryCta: "Get in touch",
  secondaryCta: "View GitHub",
  portraitLabel: "Photo of Levy",
};
